import type { QuotaGroup } from '@api/surveys/utilities/types';
import { Select } from '@utilities';
import type { SelectOption } from '@utilities/components/Select';

import styles from './_index.module.scss';

interface QuotaGroupDropdownProps {
  onQuotaGroupChange: (quotaGroupId: string) => void;
  quotaGroups: QuotaGroup[];
  selectedQuotaGroupId: string;
}

const QuotaGroupDropdown = ({
  onQuotaGroupChange,
  quotaGroups,
  selectedQuotaGroupId,
}: QuotaGroupDropdownProps) => {
  const options = quotaGroups.map(({ id, name }) => ({ label: name, value: id }));
  const selectedOption =
    options.find(({ value }) => {
      return value.toString() === selectedQuotaGroupId;
    }) || options[0];

  if (options.length < 2) {
    return null;
  }

  return (
    <Select
      className={styles['quota-group-dropdown']}
      onChange={(option) => {
        const typedOption = option as SelectOption | null;
        if (!typedOption || typedOption.value === null) {
          return;
        }
        onQuotaGroupChange(String(typedOption.value));
      }}
      options={options}
      value={selectedOption}
    />
  );
};

export default QuotaGroupDropdown;
